import { GET_TEACHERS } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TEACHERS: {
      const { teachers } = action.payload;
      return { ...state, teachers };
    }
    default:
      return state;
  }
};
